import React from "react";

const Download = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.409"
      height="24.405"
      viewBox="0 0 25.409 24.405"
    >
      <g fill="none" stroke="#7F3858" strokeWidth="2">
        <path
          d="M0 14.995h16M12.5 6L8 10.5 3.5 6M7.999 0L8 10.5"
          transform="translate(4.705 4.705)"
        ></path>
      </g>
    </svg>
  );
}

export default Download;
